export default "__VITE_ASSET__DYtRcjtv__"